import { FC } from "react";

export const ErrorPage: FC = () => {
  return <div>404 page</div>;
};
